<template>
  <div id="app">
    
    <!-- Preload hack for canvas  -->
    <preload-font-hack v-if="mustFallbackHackPreloadFonts" font="font-family: GrtskMega; font-weight: 700"/>
    <preload-font-hack v-if="mustFallbackHackPreloadFonts" font="font-family: GrtskMega; font-weight: 200"/>
    <preload-font-hack v-if="mustFallbackHackPreloadFonts" font="font-family: GrtskPeta; font-weight: 700"/>
    <preload-font-hack v-if="mustFallbackHackPreloadFonts" font="font-family: GrtskPeta; font-weight: 400"/>
    <preload-font-hack v-if="mustFallbackHackPreloadFonts" font="font-family: GrtskTera; font-weight: 200"/>
    <preload-font-hack v-if="mustFallbackHackPreloadFonts" font="font-family: GrtskTera; font-weight: 700"/>

    <SceneLogoContainer v-if="fontLoaded && $root.mobileDetected"/>
    <LayoutLoader/> 
    <LayoutHeaderMobile v-if="$root.mobileDetected" v-show="appReady" :visibility="setHeaderMobileVisibility()"/>
    <LayoutHeaderDesktop v-if="fontLoaded && !$root.mobileDetected"/>
    <!-- Router -->
    <router-view v-if="fontLoaded" :key="$route.path"></router-view>
  </div>
</template>

<script>

// App global styles
import "./styles/styles.scss"

// Helpers
import PreloadFontHack from './components/helpers/preload-font-hack'

// Components
import LayoutHeaderMobile from './components/layout/LayoutHeaderMobile'
import LayoutHeaderDesktop from './components/layout/LayoutHeaderDesktop'
import SceneLogoContainer from './components/layout/SceneLogoContainer'
import LayoutLoader from './components/layout/LayoutLoader'

// Utils
import MyEmitter from './helpers/MyEmitter'
import params from './utils/params'
import utils from './utils/utils'

export default {
  name: 'App',
  components: {
    PreloadFontHack,
    LayoutHeaderMobile,
    LayoutHeaderDesktop,
    LayoutLoader,
    SceneLogoContainer
  },
  data: function(){
    return {
      appReady: false,
      mustFallbackHackPreloadFonts: false,
      fontLoaded: false,
      seo: null,
      metaDescription: null,
      metaKeywords: null,
    }
  },  
  created(){
    this.initSeo()
  },
  mounted(){
    // dev
    if(params.DEV_SKIP_ANIM){
      MyEmitter.emit(params.Events.appHasLoadedRessources)
    }

    MyEmitter.on(params.Events.onLoaderEnd, () => {
      this.appReady = true
    })

    this.preloadFonts()
  },  
  methods: {
    updateSeo(pageName){
      
      if(this.seo){
        let matchedSeo = this.seo.find(s => s.page === pageName)

        if(matchedSeo){
          this.metaDescription.textSource = matchedSeo.metaDescription
          this.metaKeywords.textSource = matchedSeo.metaKeywords
          document.title = matchedSeo.metaTitle
        }
      }
      
    },
    initSeo: async function(){
      // get metas
      let metas = Array.from(document.querySelectorAll("meta"))
      this.metaDescription = metas.find(meta => meta.getAttribute("name") === "description")
      this.metaKeywords = metas.find(meta => meta.getAttribute("name") === "keywords")

      await utils.fetch("/seo-page").then(res => {
        this.seo = res
      }).catch(error => {
        console.error("There is no SEO", error)
      })

      // once seo has been fetched we update the seo current page
      let currentPageName = utils.capitalize(this.$route.name)
      this.updateSeo(currentPageName)

      this.$router.afterEach((to, from, next) => {

        let nextPageName = utils.capitalize(to.name)
        this.updateSeo(nextPageName)
      })
    },

    setHeaderMobileVisibility(){
      
      if(this.$route.name === "directors" || this.$route.name === "error404"){
        return "with-index"
      } 
      else if(this.$route.name === "contact" || this.$route.name === "directors-single" || this.$route.name === "private-pages-details"){

        return "hidden"
      }
      else {
        return ""
      }
      
    },

    preloadFonts: function(){


      if(!window.FontFace){
        this.mustFallbackHackPreloadFonts = true
        setTimeout(() => {
          this.fontLoaded = true
        }, 500)
        return
      }


      // all fonts
      let preloadedFonts = [
        {name: "GrtskMegaBold", url: "/preloaded-fonts/Grtsk-Mega-Bold-Latin-feldman_studio.otf", weight: "700", family: "GrtskMegaBold"},
        {name: "GrtskMegaExtralight", url: "/preloaded-fonts/Grtsk-Mega-Extralight-Latin-feldman_studio.otf", weight: "200", family: "GrtskMegaExtralight"},

        {name: "GrtskPetaBold", url: "/preloaded-fonts/Grtsk-Peta-Bold-Latin-feldman_studio.otf", weight: "700", family: "GrtskPetaBold"},
        {name: "GrtskPetaRegular", url: "/preloaded-fonts/Grtsk-Peta-Regular-Latin-feldman_studio.ttf", weight: "400", family: "GrtskPetaRegular"},

        {name: "GrtskTeraBold", url: "/preloaded-fonts/Grtsk-Tera-Bold-Latin-feldman_studio.otf", weight: "700", family: "GrtskTeraBold"},
        {name: "GrtskTeraExtralight", url: "/preloaded-fonts/Grtsk-Tera-Extralight-Latin-feldman_studio.otf", weight: "200", family: "GrtskTeraExtralight"},
      ]

      // store all fonts with promises
      preloadedFonts = preloadedFonts.map(f => {

        let font = new FontFace(f.name, `url(${f.url})`, {
          family: f.name,
          weight: f.weight
        })

        return {
          font: font,
          promise: font.load().then(res => {
            document.fonts.add(font)
          })
        }
      })

      // get all promises
      let promisesPreloadedFonts = preloadedFonts.map(f => f.promise)
      Promise.all(promisesPreloadedFonts).then(() => {
        this.fontLoaded = true
      })
    },
  }
}
</script>

<style lang="scss">

</style>
